




























































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import OutboundSelector from '@/components/selectors/Outbounds/OutboundSelector.vue';
import OutboundDetailSelector from '@/components/selectors/Outbounds/OutboundDetailSelector.vue';
import OutboundDeliveryNoteSelector from '@/components/selectors/Outbounds/OutboundDeliveryNoteSelector.vue';
import IOutbound from '@/store/models/IOutbound';
import IOutboundDetail from '@/store/models/IOutboundDetail';
import IOutboundDocument from '@/store/models/IOutboundDocument';
import IOutboundPicture from '@/store/models/IOutboundPicture';
import ICompany from '@/store/models/ICompany';
import OutboundApi from '../store/api/OutboundApi';
import OutboundDetailApi from '../store/api/OutboundDetailApi';
import OutboundDocumentApi from '../store/api/OutboundDocumentApi';
import OutboundPictureApi from '../store/api/OutboundPictureApi';
import CompanyApi from '../store/api/CompanyApi';
import CustomerApi from '../store/api/CustomerApi';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import ICustomer from '@/store/models/ICustomer';
import ListStatusOutboundsApi from '@/store/api/ListStatusOutboundsApi';
import IListStatusOutbound from '@/store/models/IListStatusOutbound';
import IGood from '@/store/models/IGood';
import GoodApi from '@/store/api/GoodApi';
import OutboundDocument from '@/components/selectors/Outbounds/OutboundDocument.vue';
import OutboundPicture from '@/components/selectors/Outbounds/OutboundPicture.vue';
import UploadServiceApi from '../store/api/UploadServiceApi';
import IListCustomPaper from '@/store/models/IListCustomPaper';
import ListCustomPapersApi from '../store/api/ListCustomPapersApi';
import IOutboundDeliveryNotes from '@/store/models/IOutboundDeliveryNotes';
import OutboundDeliveryNotesApi from '../store/api/OutboundDeliveryNotesApi';
import IWarehouse from '@/store/models/IWarehouse';
import WarehouseApi from '../store/api/WarehouseApi';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import OutbounDeliveryNotesDetailApi from '../store/api/OutboundDeliveryNotesDetailApi';
import IBlob from '@/store/models/IBlob';
import StockApi from '../store/api/StockApi';
import IStock from '@/store/models/IStock';
import IListPalletType from '@/store/models/IListPalletType';
import ListPalletTypesApi from '@/store/api/ListPalletTypesApi';
import PrintingApi from '@/store/api/PrintingApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import INotification from '@/store/models/INotification';
import NotificationApi from '@/store/api/NotificationApi';
import moment from 'moment';
import IInbound from '@/store/models/IInbound';
import InboundApi from '@/store/api/InboundApi';
import IListStatusOutboundDeliveryNotes from '@/store/models/IListStatusOutboundDeliveryNotes';
import ListStatusOutboundsDeliveryNotesApi from '@/store/api/ListStatusOutboundsDeliveryNotesApi';
import IListTypesOutbounds from '../store/models/IListTypesOutbounds';
import ListTypesOutboundsApi from '@/store/api/ListTypesOutboundsApi';
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import InboundDetailsApi from '@/store/api/InboundDetailApi';
import IInboundDetail from '@/store/models/IInboundDetail';
import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import InboundDeliveryNotesDetailApi from '@/store/api/InboundDeliveryNotesDetailApi';
import { ListOutboundTypes } from '@/components/shared/ListOutboundTypes';
import { TimeSlotCalculator } from '@/components/shared/TimeSlotCalculator';
import ListDocApi from '../store/api/ListDockApi';
import IListDoc from '@/store/models/IListDock';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        Snackbar,
        OutboundSelector,
        OutboundDocument,
        OutboundPicture,
        OutboundDetailSelector,
        OutboundDeliveryNoteSelector
    }
})
export default class Outbounds extends Vue {
    OutboundList : IOutbound[] = [];
    outboundApi : OutboundApi;
    inboundApi : InboundApi;
    inboundDetailsApi : InboundDetailsApi;
    inboundDeliveryNoteDetailApi: InboundDeliveryNotesDetailApi;
    outboundDetailApi : OutboundDetailApi;
    selectedOutbound : IOutbound = {
        id: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idCustomer: "",
        customerName: "",
        idStatus: "",
        statusName: "",
        code: "",
        dateOut: new Date(),
        dossierNumber: "",
        weight: 0,
        liters: 0,
        deliveriesNumber: 0,
        description: "",
        containerNumber: "",
        sealNumber: "",
        orderNumber: "",
        startTime: 7,
        endTime: 0,
        dateChanged: false,
        entrepot: "",
        agp: "",
        referenceInboundCode: "",
        createdDate: new Date(),
        customerDestination: "",
        codeDestination: "",
        idListTypesOutbounds: "",
        listTypesOutboundsName: "",
        statusColor: "",
        customerDestinationCountry: ""
    }
    selectedOutboundDetail : IOutboundDetail | null = null;
    selectedOutboundDeliveryNotes : IOutboundDeliveryNotes | null = null;
    permissions : IRolePermission[] = [];
    companyId : string = "";
    companyApi : CompanyApi;
    customerApi : CustomerApi;
    CompanyList : ICompany[] = [];
    CustomerList : ICustomer[] = [];
    OutboundDetailList : IOutboundDetail[] = [];
    GoodList : IGood[] = [];
    goodApi : GoodApi;
    listStatusOutboundsApi : ListStatusOutboundsApi;
    StatusOutboundsList : IListStatusOutbound[] = [];
    activeTab : number = 0;
    uploadServiceApi : UploadServiceApi;
    outboundDocuments : IOutboundDocument[] = [];
    outboundDocumentApi : OutboundDocumentApi;
    listCustomPapersApi: ListCustomPapersApi;
    CustomPaperList : IListCustomPaper[] = [];
    CompanySourceName : string = "";
    CompanyDestinationName : string = "";
    outboundDocumentsCompanySource : IOutboundDocument[] = [];
    outboundDocumentsCompanyDestination : IOutboundDocument[] = [];
    outboundPicturesCompanySource : IOutboundPicture[] = [];
    outboundPicturesCompanyDestination : IOutboundPicture[] = [];
    outboundPictures : IOutboundPicture[] = [];
    outboundPictureApi : OutboundPictureApi;
    outboundDeliveryNotesApi : OutboundDeliveryNotesApi;
    OutboundDeliveryNotesList : IOutboundDeliveryNotes[] = [];
    WarehouseList : IWarehouse[] = [];
    AllWarehouseList : IWarehouse[] = [];
    warehouseApi: WarehouseApi;
    OutboundDetailDeliveryNotesDetailList: any[] = [];
    OutboundDeliveryNotesDetailList: IOutboundDeliveryNotesDetail[] =[];
    outboundDeliveryNotesDetailApi: OutbounDeliveryNotesDetailApi;
    BlobsSource: IBlob[] = [];
    BlobsDestination: IBlob[] = [];
    enableTabsItem: boolean = false;
    enableTabsItemOutbound : boolean = false;
    overlay: boolean = false;
    overlayDeliveryNoteDetail: boolean = false;
    stockApi: StockApi;
    stockListCustomer: IStock[] = [];
    stockListCustomerPalletsAmount: IStock[] = [];
    customerStockDeliveryNoteDetail : IStock[] = [];
    PalletTypesList : IListPalletType[] = [];
    listPalletTypesApi : ListPalletTypesApi;
    OutboundCodeSelectedFromDashboard : string = "";
    printingApi : PrintingApi;
    settingsCompanyApi: SettingsCompanyApi;
    notificationApi : NotificationApi;
    userName : string = "";
    completedOutbounds : boolean = false;
    availableTimeSlots : number[] = [];
    canModifyCompletedOutbounds : boolean = false;
    listStatusOutboundsDeliveryNotesApi : ListStatusOutboundsDeliveryNotesApi;
    listStatusOutboundsDeliveryNotes : IListStatusOutboundDeliveryNotes[] = [];
    isSelectedWarehouse: boolean = false;
    isSelectedWarehouseShared: boolean = false;
    isNeededValidateT1 : boolean = false;
    isNeededValidateAGP : boolean = false;
    listTypesOutboundsApi : ListTypesOutboundsApi;
    TypesOutboundsList: IListTypesOutbounds[] = [];
    showCustomer: boolean = false;
    isStandAlone: boolean = false;
    companyLicensesApi: CompanyLicensesApi;
    hasLicensePlanning: boolean = false;
    scannerActive : boolean = false;
    listDockApi: ListDocApi;
    listDocks : IListDoc[] = [];
    outboundImportXml: boolean = false;

    constructor() {
        super();
        this.outboundApi = new OutboundApi();
        this.companyApi = new CompanyApi();
        this.customerApi = new CustomerApi();
        this.outboundDetailApi = new OutboundDetailApi("Outbounds");
        this.goodApi = new GoodApi();
        this.listStatusOutboundsApi = new ListStatusOutboundsApi();
        this.uploadServiceApi = new UploadServiceApi("Outbounds");
        this.outboundDocumentApi = new OutboundDocumentApi("Outbounds");
        this.listCustomPapersApi = new ListCustomPapersApi();
        this.outboundPictureApi = new OutboundPictureApi("Outbounds");
        this.outboundDeliveryNotesApi = new OutboundDeliveryNotesApi();
        this.warehouseApi = new WarehouseApi();
        this.outboundDeliveryNotesDetailApi = new OutbounDeliveryNotesDetailApi();
        this.stockApi = new StockApi();
        this.listPalletTypesApi = new ListPalletTypesApi();
        this.printingApi = new PrintingApi("Outbounds");
        this.settingsCompanyApi = new SettingsCompanyApi("Outbounds");
        this.notificationApi = new NotificationApi();
        this.inboundApi = new InboundApi();
        this.inboundDetailsApi = new InboundDetailsApi("Outbounds");
        this.inboundDeliveryNoteDetailApi = new InboundDeliveryNotesDetailApi();
        this.listStatusOutboundsDeliveryNotesApi = new ListStatusOutboundsDeliveryNotesApi();
        this.listTypesOutboundsApi = new ListTypesOutboundsApi();
        this.companyLicensesApi = new CompanyLicensesApi();
        this.listDockApi = new ListDocApi();
    }
    
    async created() {
        await this.getPermissions();
        await this.getWarehouses();
        await this.getCustomers();
        await this.getCompanies();
        await this.getStatusOutbounds();
        await this.getGoods();
        await this.getPalletTypes();
        await this.loadTimeSlots(new Date().toISOString().substring(0, 10), false, "", "", undefined);
        await this.getStatusOutboundsDeliveryNotes();
        await this.getTypesOutbounds();
        await this.getOutbounds();
        await this.getListDocks();
    }

    get OutboundCodeSelected() {
        if (this.selectedOutbound) {
            return "Outbound " + this.selectedOutbound.code;
        } else {
            return "Outbound";
        }
    }

    async getWarehouses() {
        this.AllWarehouseList = await this.warehouseApi.GetWarehouses();
    }

    @Watch('OutboundList')
    onChangeOutboundList() {
        let index = this.OutboundList.findIndex(i => i.id === this.$route.params.data);
        if (index !== -1) {
            this.OutboundCodeSelectedFromDashboard = this.OutboundList[index].code;
        } else {
            index = this.OutboundList.findIndex(i => i.code === this.$route.params.data);
            if (index !== -1) {
                this.OutboundCodeSelectedFromDashboard = this.OutboundList[index].code;
            }
        }
    }

    @Watch('selectedOutboundDeliveryNotes')
    async onChangeSelectedOutboundDeliveryNotes() {
        if (this.selectedOutboundDeliveryNotes) {
            if (this.selectedOutboundDeliveryNotes.idWarehouse !== "") {
                let warehouses: IWarehouse[] = await this.warehouseApi.IsWarehouseShared(this.companyId, this.selectedOutboundDeliveryNotes.idWarehouse);
                this.isSelectedWarehouseShared = warehouses.length > 0;
            }
        }
    }

    async getStockPalletsAmount(item: IOutboundDetail) {
        let index = this.WarehouseList.findIndex(i => i.name === item.warehouseName);
        if (index !== -1) {
            item.idWarehouse = this.WarehouseList[index].id;
            this.stockListCustomerPalletsAmount = await this.stockApi.GetStockPalletsAmount(item);
        }
    }

    async loadTimeSlots(time: string, isDateChanged: boolean, idCompanyDestination: string, idCompanySource: string, startTime?: number) {
        const calculator = new TimeSlotCalculator(
            this.inboundApi.GetInboundsByDate.bind(this.inboundApi),
            this.outboundApi.GetOutboundsByDate.bind(this.outboundApi),
            this.inboundApi.GetInboundsByDateOtherCompanies.bind(this.inboundApi),
            this.outboundApi.GetOutboundsByDateOtherCompanies.bind(this.outboundApi)
        );

        const effectiveStartTime =
            (startTime !== undefined && startTime !== null)
                ? startTime
                : (this.selectedOutbound && this.selectedOutbound.startTime ? this.selectedOutbound.startTime : undefined);

        const companySourceId = idCompanySource || (this.selectedOutbound ? this.selectedOutbound.idCompanySource : "");
        const companyDestinationId = idCompanyDestination || (this.selectedOutbound ? this.selectedOutbound.idCompanyDestination : "");

        this.availableTimeSlots = await calculator.getAvailableTimeSlots(
            time,
            companyDestinationId,
            companySourceId,
            companyDestinationId,
            effectiveStartTime,
            isDateChanged
        );
    }

    async showCompletedOutbounds(completedOutbounds : boolean) {
        if (completedOutbounds) {
            this.OutboundList = [];
            this.OutboundList = await this.outboundApi.GetOutboundsCompleted(this.companyId);
            if (this.showCustomer === false) {
                this.OutboundList.forEach((i) => {
                    let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                    if (indexCustomer !== -1) {
                        if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                            i.customerName = "";
                        }
                    } else {
                        i.customerName = "";
                    }
                });
            }
        } else {
            if (this.completedOutbounds) {
                this.OutboundList = [];
                this.getOutbounds();
            }
        }
        this.completedOutbounds = completedOutbounds;
    }

    get isSuperAdmin() {
        return this.companyId === EMPTY_GUID;
    }

    async printOutboundDetail(formatToPrint : string) {
        if (this.isSuperAdmin === false) {
            this.overlay = true;
            let settingsCompany = SettingsCompany.Settings.IdOutboundPrinting;
            let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (idRepport) {
                let ids: string[] = [this.selectedOutbound!.id];
                let printLabelUrl: string = await this.printingApi.Print(idRepport[0].value, "IdOutbound", ids, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "OutboundDetail.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + settingsCompany + " could not be found");
            }
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printOutboundDeliveryNotes(formatToPrint : string) {
        if (this.isSuperAdmin === false) {
            this.overlay = true;
            let settingsCompany = SettingsCompany.Settings.IdOutboundDeliveryNotePrinting;
            let idRepport : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (idRepport) {
                let ids : string[] = [this.selectedOutboundDeliveryNotes!.id];
                let printLabelUrl: string = await this.printingApi.Print(idRepport[0].value, "IdOutboundDeliveryNote", ids, formatToPrint);
                if (printLabelUrl) {
                    this.uploadServiceApi.DownloadDocuments(printLabelUrl, "OutboundDeliveryNotes.xlsx");
                }
            } else {
                this.showMessageWarning("Setting " + settingsCompany + " could not be found");
            }
            this.overlay = false;
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.companyId = userFromStorage.idCompany;
        this.userName = userFromStorage.username;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Outbounds"));
        let settingsCompany = SettingsCompany.Settings.IdUserCanModifyInOutbounds;
        let licencesForms: ICompaniesLicence[] = [];
        licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.companyId);
        this.hasLicensePlanning = !licencesForms.some(license => license.formName.toLocaleLowerCase() === "planning");
        let hasLicenseScanner = licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length === 0) {
            this.canModifyCompletedOutbounds = false;
        } else {
            this.canModifyCompletedOutbounds = setting.some(s =>
                s.value.toLocaleLowerCase() === userFromStorage.idPerson.toLocaleLowerCase()
            );
        }
        settingsCompany = SettingsCompany.Settings.ValidationT1;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            this.isNeededValidateT1 = true;
        }
        settingsCompany = SettingsCompany.Settings.ValidationAGP;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            this.isNeededValidateAGP = true;
        }
        settingsCompany = SettingsCompany.Settings.ShowCustomer;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting.length > 0) {
                if (setting[0].value === "No") {
                    this.showCustomer = false;
                } else {
                    this.showCustomer = true;
                }
            }
        }
        settingsCompany = SettingsCompany.Settings.StandAlone;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value.toLocaleLowerCase() === "yes") {
                this.isStandAlone = true;
            }
        }
        if (!hasLicenseScanner) {
            this.scannerActive = true;
            settingsCompany = SettingsCompany.Settings.Scanner;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
            if (setting.length > 0) {
                this.scannerActive = setting[0].value.toLocaleLowerCase() === "yes";
            }
        }
        settingsCompany = SettingsCompany.Settings.OutboundImportXml;
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.companyId, settingsCompany);
        if (setting.length > 0) {
            if (setting[0].value.toLocaleLowerCase() === "yes") {
                this.outboundImportXml = true;
            }
        }
    }

    async outboundChanged(outbound: IOutbound) {
        this.overlay = true;

        try {
            if (outbound && Object.keys(outbound).length !== 0 && outbound.id !== "") {
                this.enableTabsItemOutbound = true;
                this.CompanySourceName = outbound.companySourceName;
                this.CompanyDestinationName = outbound.companyDestinationName;
                this.enableTabsItem = true;

                const warehousesCompany =
                    outbound.idCompanyDestination === this.companyId
                        ? outbound.idCompanyDestination
                        : this.companyId;

                await Promise.all([
                    this.getOutboundDetails(outbound.id),
                    this.getStockListCustomer(outbound.idCustomer),
                    this.getOutboundDeliveryNotes(outbound.id),
                    this.getListCustomPapers(),
                    this.getOutboundDocuments(outbound.id),
                    this.getWarehousesByIdCompany(warehousesCompany),
                    this.loadTimeSlots(moment(outbound.dateOut).format("YYYY-MM-DD"), false, outbound.idCompanyDestination, outbound.idCompanySource, outbound.startTime),
                    this.getOutboundPictures(outbound.id)
                ]);
            } else {
                this.enableTabsItemOutbound = false;
                this.selectedOutboundDeliveryNotes = null;
                this.OutboundDetailList = [];
                this.OutboundDeliveryNotesList = [];
                this.OutboundDeliveryNotesDetailList = [];
                this.OutboundDetailDeliveryNotesDetailList = [];
                this.outboundDocuments = [];
                this.outboundPictures = [];
                this.customerStockDeliveryNoteDetail = [];
                this.activeTab = 0;
                this.enableTabsItem = false;
            }
        } finally {
            this.overlay = false;
        }
    }

    async outboundDeliveryNoteChanged(outboundDeliveryNote : IOutboundDeliveryNotes) {
        if (outboundDeliveryNote !== undefined && Object.keys(outboundDeliveryNote).length !== 0) {
            this.OutboundDeliveryNotesDetailList = await this.outboundDeliveryNotesDetailApi.GetOutboundDeliveryNotesDetail(outboundDeliveryNote.id);
        }
    }

    async getPalletTypes() {
        this.PalletTypesList = await this.listPalletTypesApi.GetListPalleTypes();
    }

    async getStockListCustomerEvent(customerId: string) {
        await this.getStockListCustomer(customerId);
        if (this.stockListCustomer.length === 0) {
            this.showMessageWarning("There is no material in stock for this customer. Please check that the stock is not reserved in a Sell or other Outbound.");
        }
    }

    async getStockListCustomer(customerId: string) {
        this.stockListCustomer = [];

        const allStock = await this.stockApi.GetStockGroupByPalletsAndCustomer(customerId);
        const idCompanyDest = this.selectedOutbound!.idCompanyDestination;

        // ✅ FILTRO por compañía destino
        // Ajusta el campo del stock según tu modelo:
        // - si tu DTO tiene `idCompany` -> usa s.idCompany
        // - si tiene `idCompanyWarehouse` / `idCompanyOwner` / etc -> usa ese
        const filteredStock = idCompanyDest
            ? allStock.filter(s => (s.idCompanyDestination === idCompanyDest))
            : allStock;

        this.stockListCustomer = filteredStock;

        let index = 0;
        this.stockListCustomer.forEach(s => {
            if (s.id === undefined) {
                s.id = String(index++);
            }
        });
    }
    
    async getListDocks() {
        this.listDocks = await this.listDockApi.GetListDocks(this.companyId);
    }

    async getWarehousesByIdCompany(idCompany : string) {
        this.WarehouseList = await this.warehouseApi.GetWarehousesShared(idCompany);
    }

    async getListCustomPapers() {
        this.CustomPaperList = await this.listCustomPapersApi.GetListCustomPapers();
    }

    async getTypesOutbounds() {
        this.TypesOutboundsList = await this.listTypesOutboundsApi.GetListTypesOutbounds();
    }

    async getOutboundDocuments(outboundId : string) {
        this.outboundDocuments = await this.outboundDocumentApi.GetOutboundDocuments(outboundId);
    }

    async getOutboundPictures(outboundId : string) {
        this.BlobsSource = [];
        this.BlobsDestination = [];
        this.outboundPicturesCompanySource = [];
        this.outboundPicturesCompanyDestination = [];
        this.outboundPictures = await this.outboundPictureApi.GetOutboundPictures(outboundId);
    }

    async getCustomerStockFiltered(outboundDeliveryNote : IOutboundDeliveryNotes) {
        this.overlay = true;
        let idGoods : string[] = this.OutboundDetailList.map(g => g.idGood);
        let idInboundsDeliveryNoteDetails = this.OutboundDetailList.map(g => g.idInboundDeliveryNoteDetail);
        this.customerStockDeliveryNoteDetail = await this.stockApi.GetStockGroupByGoods(idGoods, idInboundsDeliveryNoteDetails);
        this.customerStockDeliveryNoteDetail = this.customerStockDeliveryNoteDetail.filter(c => c.idWarehouse === outboundDeliveryNote.idWarehouse);
        this.overlay = false;
    }

    @Watch('outboundDocuments')
    onChangedOutboundDocuments() {
        this.outboundDocumentsCompanySource = this.outboundDocuments.filter(i => i.idCompany === this.selectedOutbound!.idCompanySource);
        this.outboundDocumentsCompanyDestination = this.outboundDocuments.filter(i => i.idCompany === this.selectedOutbound!.idCompanyDestination);
    }

    @Watch('outboundPictures')
    async onChangedOutboundPictures() {
        this.outboundPictures.forEach(i => {
            if (this.selectedOutbound) {
                if (i.idCompany === this.selectedOutbound.idCompanySource) {
                    this.outboundPicturesCompanySource.push(i);
                } else if (i.idCompany === this.selectedOutbound.idCompanyDestination) {
                    this.outboundPicturesCompanyDestination.push(i);
                } else {
                    this.outboundPicturesCompanyDestination.push(i);
                }
            }
        });
        this.outboundPicturesCompanySource.forEach(async i => {
            let indexUrl = this.BlobsSource.findIndex(b => b.url === i.url);
            if (indexUrl === -1) {
                let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                let blob: IBlob = {} as IBlob;
                blob.id = i.id;
                blob.url = i.url;
                blob.blobUrl = blobUrl;
                blob.inboundId = this.selectedOutbound!.id;
                let index = this.BlobsSource.findIndex(b => b.id === i.id);
                if (index === -1) {
                    this.BlobsSource.push(blob);
                }
            }
        });
        this.outboundPicturesCompanyDestination.forEach(async i => {
            let indexUrl = this.BlobsDestination.findIndex(b => b.url === i.url);
            if (indexUrl === -1) {
                let blobUrl = await this.uploadServiceApi.DownloadPictures(i.url);
                let blob: IBlob = {} as IBlob;
                blob.id = i.id;
                blob.url = i.url;
                blob.blobUrl = blobUrl;
                blob.inboundId = this.selectedOutbound!.id;
                let index = this.BlobsDestination.findIndex(b => b.id === i.id);
                if (index === -1) {
                    this.BlobsDestination.push(blob);
                }
            }
        });
    }

    async saveNotification(editedOutbound: IOutbound, notificationText : string) {
        this.overlay = true;
        if (this.canEditOutbound(editedOutbound) === true) {
            let idCompanyToNotify : string = "";
            if (this.companyId === editedOutbound.idCompanySource) {
                idCompanyToNotify = editedOutbound.idCompanyDestination;
            } else {
                idCompanyToNotify = editedOutbound.idCompanySource;
            }
            let notification : INotification = {
                subject: "Status outbound " + editedOutbound.code + " changed to " + editedOutbound.statusName,
                body: notificationText,
                type: "OUTBOUND",
                identifier: editedOutbound.id,
                destinationCompany: idCompanyToNotify
            };
            await this.notificationApi.SaveNotification(notification);
            this.showMessageInfo("The notification has been successfully sent to all users of the " + editedOutbound.companySourceName + " company.");
        } else {
            this.showMessageWarning("Unable to change inbound status to completed because there are incomplete delivery notes. Notifications will not be sent.");
        }
        this.overlay = false;
    }

    canEditOutbound(editedOutbound : IOutbound) : boolean {
        this.overlay = true;
        let canEdit: boolean = true;
        if (editedOutbound.statusName.toLowerCase() === 'completed') {
            if (this.OutboundDetailList.length > 0) {
                for (let i = 0; i < this.OutboundDetailList.length; i++) {
                    canEdit = this.OutboundDetailList[i].totalCases === this.OutboundDetailList[i].inDeliveryNote;
                    if (canEdit === false) {
                        return canEdit;
                    }
                }
                return canEdit;
            }
        }
        this.overlay = true;
        return canEdit;
    }
   
    async getOutboundDeliveryNotes(selectedOutboundId : string) {
        this.OutboundDeliveryNotesList = await this.outboundDeliveryNotesApi.GetOutboundDeliveryNotes(selectedOutboundId);
        if (this.showCustomer === false) {
            this.OutboundDeliveryNotesList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
    }

    resetOutboundDeliveryNotes() {
        this.selectedOutboundDeliveryNotes = null;
        this.OutboundDeliveryNotesDetailList = [];
    }

    deleteOutboundDeliveryNotes (item: IOutboundDeliveryNotes) {
        confirm('Are you sure you want to delete this outbound deliveryNote?') && this.deleteOutboundDeliveryNotesItem(item);
    }

    async deleteOutboundDeliveryNotesItem(outboundDeliveryNotes: IOutboundDeliveryNotes) {
        this.overlay = true;
        let resultDeleteOutboundDeliveryNoteDetail: boolean = await this.outboundDeliveryNotesDetailApi.DeleteOutboundDeliveryNotesDetailByOutboundDeliveryNoteId(outboundDeliveryNotes.id);
        if (resultDeleteOutboundDeliveryNoteDetail === false) {
            const errors: string = this.outboundDeliveryNotesDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        } else {
            let result: boolean = await this.outboundDeliveryNotesApi.DeleteOutboundDeliveryNotes(outboundDeliveryNotes.id);
            if (result) {
                const index = this.OutboundDeliveryNotesList.indexOf(outboundDeliveryNotes);
                this.OutboundDeliveryNotesList.splice(index, 1);
                this.getOutboundDetails(outboundDeliveryNotes.idOutbound);
                this.showMessageInfo(`The outbound deliveryNote ${outboundDeliveryNotes.code} has been successfully deleted`);
            } else {
                const errors: string = this.outboundDeliveryNotesApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.overlay = false;
    }

    async getStatusOutboundsDeliveryNotes() {
        this.listStatusOutboundsDeliveryNotes = await this.listStatusOutboundsDeliveryNotesApi.GetListStatusOutboundDeliveryNotes();
    }

    async isWarehouseShared(idWarehouse: string) : Promise<boolean> {
        let warehouses: any[] = await this.warehouseApi.IsWarehouseShared(this.companyId, idWarehouse);
        return warehouses.length > 0;
    }

    async saveOutboundDeliveryNotes(outboundDeliveryNote: IOutboundDeliveryNotes) {
        this.overlay = true;
        let isWarehouseShared = await this.isWarehouseShared(outboundDeliveryNote.idWarehouse);
        if (isWarehouseShared === true) {
            let statusPending = this.listStatusOutboundsDeliveryNotes.find(c => c.isFinished === false) as IListStatusOutboundDeliveryNotes;
            outboundDeliveryNote.idStatus = statusPending.id;
            outboundDeliveryNote.statusName = statusPending.name;
            // create notification
        } else {
            let statusCompleted = this.listStatusOutboundsDeliveryNotes.find(c => c.isFinished === true) as IListStatusOutboundDeliveryNotes;
            outboundDeliveryNote.idStatus = statusCompleted.id;
            outboundDeliveryNote.statusName = statusCompleted.name;
        }
        
        if (this.selectedOutbound) {
            if (outboundDeliveryNote.code === "") {
                outboundDeliveryNote.code = this.selectedOutbound.code;
            }
            outboundDeliveryNote.codeSource = this.selectedOutbound.code;
            outboundDeliveryNote.codeDestination = this.selectedOutbound.codeDestination;
        }
        const id = await this.outboundDeliveryNotesApi.SaveOutboundDeliveryNotes(outboundDeliveryNote);
        if (id) {
            outboundDeliveryNote.id = id;
            this.OutboundDeliveryNotesList = [outboundDeliveryNote].concat(this.OutboundDeliveryNotesList);
            this.selectedOutboundDeliveryNotes = outboundDeliveryNote;
            this.showMessageInfo(`The outbound delivery note ${outboundDeliveryNote.code} has been successfully saved`);
        } else {
            const errors: string = this.outboundDeliveryNotesApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editOutboundDeliveryNotes (editedOutboundDeliveryNotes: IOutboundDeliveryNotes) {
        this.overlay = true;
        let result : boolean = await this.outboundDeliveryNotesApi.UpdateOutboundDeliveryNotes(editedOutboundDeliveryNotes);
        if (result) {
            this.showMessageInfo(`The outbound deliveryNotes ${editedOutboundDeliveryNotes.code} has been successfully edited`);
        } else {
            const errors: string = this.outboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async getStatusOutbounds() {
        this.StatusOutboundsList = await this.listStatusOutboundsApi.GetListStatusOutbounds();
    }

    async getGoods() {
        this.GoodList = await this.goodApi.GetGoods();
    }
    
    async getOutbounds() {
        this.overlay = true;
        if (this.CustomerList.length === 0) {
            await this.getCustomers();
        }
        this.OutboundList = await this.outboundApi.GetOutbounds(this.companyId);
        if (this.showCustomer === false) {
            this.OutboundList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.companyId !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
        this.overlay = false;
    }

    async getOutboundDetails(outboundId: string) {
        this.overlay = true;
        this.OutboundDetailList = await this.outboundDetailApi.GetOutboundDetails(outboundId);

        const outboundType = this.selectedOutbound!.listTypesOutboundsName.toLowerCase();

        // --- Caso 1: Entrepot / T1 (mantiene tu lógica actual) ---
        if (outboundType === ListOutboundTypes.Types.Entrepot || outboundType === ListOutboundTypes.Types.T1) {
            this.OutboundDetailList.forEach(async o => {
                const inbound: IInbound[] = await this.inboundApi.GetInboundById(o.idInbound);
                if (inbound.length === 0) return;

                const inboundDetails: IInboundDetail[] = await this.inboundDetailsApi.GetInboundDetails(inbound[0].id);
                if (inboundDetails.length === 0) return;

                const index = this.OutboundDetailList.findIndex(p => p.id === o.id);
                if (index === -1) return;

                const inboundWeight = Number(inbound[0].weight) || 0;
                const inboundLiters = Number(inbound[0].liters) || 0;
                const inboundValue = Number(inbound[0].totalValue) || 0;
                const totalCases = inboundDetails.reduce((sum, item) => sum + Number(item.totalCases || 0), 0) || 1;

                const calculatedWeight = inboundWeight > 0 ? (inboundWeight / totalCases) * o.totalCases : null;
                const calculatedLiters = inboundLiters > 0 ? (inboundLiters / totalCases) * o.totalCases : null;
                const calculatedValue = inboundValue > 0 ? (inboundValue / totalCases) * o.totalCases : null;

                const current = this.OutboundDetailList[index];
                let shouldUpdate = false;

                if (calculatedWeight !== null && current.weight !== calculatedWeight) {
                    current.weight = calculatedWeight;
                    shouldUpdate = true;
                }

                if (calculatedLiters !== null && current.liters !== calculatedLiters) {
                    current.liters = calculatedLiters;
                    shouldUpdate = true;
                }

                if (calculatedValue !== null && current.totalValue !== calculatedValue) {
                    current.totalValue = calculatedValue;
                    shouldUpdate = true;
                }

                if (shouldUpdate) await this.outboundDetailApi.UpdateOutboundDetail(current);
            });
        }

        this.overlay = false;
    }

    async getCompanies() {
        this.CompanyList = await this.companyApi.GetCompanies();
    }

    async getCustomers() {
        this.CustomerList = await this.customerApi.GetCustomers();
    }

    async setCompanies() {
        this.OutboundList.forEach((i) => {
            let companySource : ICompany = this.CompanyList.find(c => c.id === i.idCompanySource) as ICompany;
            i.companySourceName = companySource.name;
            let companyDestination : ICompany = this.CompanyList.find(c => c.id === i.idCompanyDestination) as ICompany;
            i.companyDestinationName = companyDestination.name;
        });
    }

    deleteOutbound (item: IOutbound) {
        confirm('Are you sure you want to delete this outbound?') && this.deleteOutboundItem(item);
    }

    async deleteOutboundItem(outbound: IOutbound) {
        this.overlay = true;
        let resultDeleteOutboundDeliveryNoteDetail: boolean = await this.outboundDeliveryNotesDetailApi.DeleteOutboundDeliveryNotesDetailByOutboundId(outbound.id);
        if (resultDeleteOutboundDeliveryNoteDetail === false) {
            const errors: string = this.outboundDeliveryNotesDetailApi.getModelError().join("; ");
            this.showMessageError(errors);
        } else {
            let resultDeleteOutboundDeliveryNote : boolean = await this.outboundDeliveryNotesApi.DeleteOutboundDeliveryNotesByOutboundId(outbound.id);
            if (resultDeleteOutboundDeliveryNote === false) {
                const errors: string = this.outboundDeliveryNotesApi.getModelError().join("; ");
                this.showMessageError(errors);
            } else {
                let resultDeleteOutboundDetail : boolean = await this.outboundDetailApi.DeleteOutboundDetailByOutboundId(outbound.id);
                if (resultDeleteOutboundDetail === false) {
                    const errors: string = this.outboundDetailApi.getModelError().join("; ");
                    this.showMessageError(errors);
                } else {
                    let resultDeleteOutboundDocument : boolean = await this.outboundDocumentApi.DeleteOutboundDocumentByOutboundId(outbound.id);
                    if (resultDeleteOutboundDocument === false) {
                        const errors: string = this.outboundDocumentApi.getModelError().join("; ");
                        this.showMessageError(errors);
                    } else {
                        let resultDeleteOutboundPicture : boolean = await this.outboundPictureApi.DeleteOutboundPictureByOutboundId(outbound.id);
                        if (resultDeleteOutboundPicture === false) {
                            const errors: string = this.outboundPictureApi.getModelError().join("; ");
                            this.showMessageError(errors);
                        } else {
                            this.OutboundDetailList = [];
                            this.OutboundDeliveryNotesList = [];
                            this.outboundDocuments = [];
                            this.outboundPictures = [];
                            let result: boolean = await this.outboundApi.DeleteOutbound(outbound.id);
                            if (result) {
                                const index = this.OutboundList.indexOf(outbound);
                                this.OutboundList.splice(index, 1);
                                this.showMessageInfo(`The outbound ${outbound.code} has been successfully deleted`);
                            } else {
                                const errors: string = this.outboundApi.getModelError().join("; ");
                                this.showMessageError(errors);
                            }
                        }
                    }
                }
            }
        }
        this.overlay = false;
    }

    async saveOutbound (outbound: IOutbound) {
        this.overlay = true;
        if (outbound.code === "") {
            let code: any = await this.companyApi.GetNextCode(this.companyId, "Outbounds");
            if (code[0].column1 > 0) {
                outbound.code = code[0].column1.toString();
            }
        }
        const id = await this.outboundApi.SaveOutbound(outbound);
        if (id) {
            outbound.id = id;
            this.OutboundList = [outbound].concat(this.OutboundList);
            this.selectedOutbound = outbound;
            this.showMessageInfo(`The outbound ${outbound.code} has been successfully saved`);
        } else {
            const errors: string = this.outboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editOutbound(editedOutbound: IOutbound) {
        this.overlay = true;

        // 1. ¿Se puede editar?
        if (!this.canEditOutbound(editedOutbound)) {
            this.showMessageWarning(
                "Unable to change outbound status to completed because there are incomplete delivery notes."
            );
            this.overlay = false;
            return;
        }

        // 2. Validaciones T1
        if (this.isNeededValidateT1 &&
            editedOutbound.listTypesOutboundsName.toLowerCase() === ListOutboundTypes.Types.T1.toLowerCase()) {
            if (!this.validationT1Document(editedOutbound)) {
                this.showMessageWarning(
                    "The outbound status cannot be changed to completed because the outbound requires a T1 document but none has been added."
                );
                this.overlay = false;
                return;
            }

            // Generación automática de codeDestination si procede
            if (editedOutbound.idCompanySource !== editedOutbound.idCompanyDestination) {
                const userFromStorage: IAuthentication =
                    JSON.parse(sessionStorage.getItem("user") || "{}");

                const settingType = SettingsCompany.Settings.GenerateCode;
                const settings: ISettingsCompany[] =
                    await this.settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingType);

                if (settings.length > 0 && (!editedOutbound.codeDestination || editedOutbound.codeDestination === "")) {
                    const code: any = await this.companyApi.GetNextCode(this.companyId, "Outbounds");
                    if (code[0].column1 > 0) {
                        editedOutbound.codeDestination = code[0].column1.toString();
                    }
                }
            }
        }

        // 3. Validaciones AGP
        if (this.isNeededValidateAGP &&
            editedOutbound.listTypesOutboundsName.toLowerCase() === ListOutboundTypes.Types.AGP.toLowerCase()) {
            if (!this.validationAGPDocument(editedOutbound)) {
                this.showMessageWarning(
                    "The outbound cannot be completed because an E-AD of Inklaring of Maandaangifte AGP document is required for AGP type outbounds."
                );
                this.overlay = false;
                return;
            }
        }

        // 4. Si llegó aquí → todo OK → actualizar outbound
        await this.updateOutbound(editedOutbound);

        this.overlay = false;
    }

    async updateOutbound (editedOutbound : IOutbound) {
        let result : boolean = await this.outboundApi.UpdateOutbound(editedOutbound);
        if (result) {
            this.getOutbounds();
            this.selectedOutbound = editedOutbound;
            this.showMessageInfo(`The outbound ${editedOutbound.code} has been successfully edited`);
        } else {
            const errors: string = this.outboundApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    validationAGPDocument(editedOutbound : IOutbound) : boolean {
        if (editedOutbound.statusName.toLocaleLowerCase() === 'completed') {
            if (this.OutboundDetailList.length > 0) {
                const inboundDetailWithEAD = this.OutboundDetailList.filter(d => d.documentation === true);
                if (inboundDetailWithEAD.length > 0) {
                    const documentsWithEAD: IOutboundDocument[] = this.outboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 'e-ad'
                    );
                    const documentsWithInklaring: IOutboundDocument[] = this.outboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 'inklaring'
                    );
                    const documentsWithMaandaangifte: IOutboundDocument[] = this.outboundDocuments.filter(doc =>
                        doc.custompapername.toLowerCase() === 'maandaangifte agp'
                    );
                    if (documentsWithEAD.length < 1 && documentsWithInklaring.length < 1 && documentsWithMaandaangifte.length < 1) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    validationT1Document(editedOutbound : IOutbound) : boolean {
        if (editedOutbound.statusName.toLocaleLowerCase() === 'completed') {
            if (this.OutboundDetailList.length > 0) {
                // const outboundDetailWithT1 = this.OutboundDetailList.filter(d => d.documentation === true);
                // if (outboundDetailWithT1.length > 0) {
                const documentsWithT1: IOutboundDocument[] = this.outboundDocuments.filter(doc =>
                    doc.custompapername.toLowerCase() === 't1 document'
                );
                if (documentsWithT1.length < 1) {
                    return false;
                }
                // }
            }
        }
        return true;
    }

    ValidateOutbound() {
        let isValid : boolean = true;
        this.OutboundDetailList.forEach(o => {
            if (o.totalCases !== o.inDeliveryNote) {
                isValid = false;
            }
        });
        return isValid;
    }

    async getCustomerStock() {
        this.overlay = true;
        try {
            await this.getStockListCustomerEvent(this.selectedOutbound!.idCustomer);
        } finally {
            this.overlay = false;
        }
    }

    deleteOutboundDetail (item: IOutboundDetail) {
        confirm('Are you sure you want to delete this outbound detail?') && this.deleteOutboundDetailItem(item);
    }

    async deleteOutboundDetailItem(outboundDetail: IOutboundDetail) {
        this.overlay = true;
        try {
            let details = [];

            const allDetails = await Promise.all(
                this.OutboundDeliveryNotesList.map(d =>
                    this.outboundDeliveryNotesDetailApi.GetOutboundDeliveryNotesDetail(d.id)
                )
            );

            details = allDetails.flat();

            const isUsedInDeliveryNote = details.some(
                d => d.idOutboundDetail === outboundDetail.id
            );

            if (isUsedInDeliveryNote) {
                this.showMessageWarning(
                    `The outbound detail ${outboundDetail.goodName} cannot be deleted because it is used in an outbound delivery note.`
                );
                return;
            }

            let result: boolean = await this.outboundDetailApi.DeleteOutboundDetail(outboundDetail.id);
            if (result) {
                const index = this.OutboundDetailList.findIndex(x => x.id === outboundDetail.id);
                if (index !== -1) {
                    this.OutboundDetailList.splice(index, 1);
                }

                if (this.selectedOutboundDetail && this.selectedOutboundDetail.id === outboundDetail.id) {
                    this.selectedOutboundDetail = null;
                }

                this.showMessageInfo(`The outbound detail ${outboundDetail.goodName} has been successfully deleted`);
            } else {
                const errors: string = this.outboundDetailApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        } catch (error) {
            console.error("Error fetching outbound delivery notes details:", error);
            this.showMessageError("An error occurred while loading delivery note details.");
        } finally {
            this.overlay = false;
        }
    }

    async createdOutboundDetail(stockCustomerDetail: IStock) {
        let safeLower = (value: string | null | undefined) => (value || "").toLocaleLowerCase();

        let outbounDetail : IOutboundDetail = {} as IOutboundDetail;
        outbounDetail.idOutbound = this.selectedOutbound!.id;
        outbounDetail.idGood = stockCustomerDetail.idGood;
        outbounDetail.goodName = stockCustomerDetail.goodName;
        outbounDetail.idInboundDeliveryNoteDetail = stockCustomerDetail.idInboundDeliveryNoteDetail;
        outbounDetail.codeInbound = stockCustomerDetail.codeInbounds;
        outbounDetail.totalCases = stockCustomerDetail.totalCases;
        outbounDetail.goodsPerCase = stockCustomerDetail.goodsPerCase;
        let goodPerCase = stockCustomerDetail.goodsPerCase === 0 ? 1 : stockCustomerDetail.goodsPerCase;
        outbounDetail.totalGoods = stockCustomerDetail.totalCases * goodPerCase;
        
        // FIX #1: comparar warehouseName de forma segura
        if (outbounDetail.idWarehouse === null) {
            if ((outbounDetail.warehouseName || "") !== "") {
                let index = this.AllWarehouseList.findIndex(
                    w => safeLower(w.name) === safeLower(outbounDetail.warehouseName)
                );
                if (index !== -1) {
                    outbounDetail.idWarehouse = this.AllWarehouseList[index].id;
                }
            }
        }

        outbounDetail.idWarehouse = stockCustomerDetail.idWarehouse;
        outbounDetail.warehouseName = stockCustomerDetail.warehouseName;
        outbounDetail.bestBeforeDate = stockCustomerDetail.bestBeforeDate;
        outbounDetail.documentation = stockCustomerDetail.documentation;
        let inbound: IInbound[] = await this.inboundApi.GetInboundById(stockCustomerDetail.idInbound);

        if (inbound && inbound.length > 0) {
            let detailDeliveryNote: IInboundDeliveryNotesDetail[] =
                await this.inboundDeliveryNoteDetailApi.GetInboundDeliveryNotesDetailById(
                    stockCustomerDetail.idInboundDeliveryNoteDetail
                );

            if (detailDeliveryNote.length > 0) {
                if (inbound[0].listTypesInboundsName.toLocaleLowerCase() !== ListOutboundTypes.Types.Entrepot.toLocaleLowerCase() || inbound[0].listTypesInboundsName.toLocaleLowerCase() !== ListOutboundTypes.Types.T1.toLocaleLowerCase()) {
                    outbounDetail.weight = stockCustomerDetail.weight;
                } else {
                    let inboundDetail: IInboundDetail[] = await this.inboundDetailsApi.GetInboundDetails(inbound[0].id);
                    let totalInboundCases: number = inboundDetail.reduce((sum, detail) => sum + (detail.totalCases || 0), 0);

                    if (inboundDetail && inboundDetail.length > 0) {
                        if (inbound[0].weight > 0 && detailDeliveryNote.length > 0) {
                            outbounDetail.weight = (inbound[0].weight / totalInboundCases) * stockCustomerDetail.totalCases;
                        }
                        if (inbound[0].liters > 0 && detailDeliveryNote.length > 0) {
                            outbounDetail.liters = (inbound[0].liters / totalInboundCases) * stockCustomerDetail.totalCases;
                        }
                        if (inbound[0].totalValue > 0 && detailDeliveryNote.length > 0) {
                            outbounDetail.totalValue = (inbound[0].totalValue / totalInboundCases) * stockCustomerDetail.totalCases;
                        }
                    }
                }
            }
        }
        return outbounDetail;
    }

    async uploadOutboundDocument(formData: FormData, fileNames: string[], selectedCustomPaper: IListCustomPaper[]) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);

        let successCount = 0;
        let failCount = 0;

        for (let i = 0; i < fileNames.length; i++) {
            const fileName = fileNames[i];
            const fileUrl = urls[i];

            // Validar que realmente haya URL devuelta
            if (!fileUrl) {
                this.showMessageError(`❌ File "${fileName}" could not be uploaded (no URL returned).`);
                failCount++;
                continue;
            }

            let inboundDocument: IOutboundDocument = {
                id: "",
                idListCustomPaper: selectedCustomPaper[i].id,
                custompapername: selectedCustomPaper[i].name,
                description: fileName,
                url: fileUrl,
                idCompany: this.companyId,
                idOutbound: this.selectedOutbound!.id
            };

            const id = await this.outboundDocumentApi.SaveOutboundDocument(inboundDocument);
            if (id) {
                inboundDocument.id = id;
                this.outboundDocuments.push(inboundDocument);
                successCount++;
            } else {
                const errors: string = this.outboundDocumentApi.getModelError().join("; ");
                this.showMessageError(`❌ File "${fileName}" could not be saved: ${errors}`);
                failCount++;
            }
        }

        // Mostrar resumen final
        if (successCount > 0) {
            this.showMessageInfo(`✅ ${successCount} document(s) uploaded and saved successfully.`);
        }
        if (failCount > 0) {
            this.showMessageWarning(`⚠️ ${failCount} document(s) failed.`);
        }

        this.overlay = false;
    }

    async downloadOutboundDocument(outboundDocument: any) {
        this.uploadServiceApi.DownloadDocuments(outboundDocument.url, outboundDocument.description);
    }

    async downloadOutboundPictures(outboundsPictures: IOutboundPicture[]) {
        this.overlay = true;
        const urls = outboundsPictures.map(element => element.url);
        if (this.selectedOutbound) {
            const zipFileName = this.selectedOutbound.code + "_" + new Date().toISOString().substr(0, 10);
            await this.uploadServiceApi.DownloadZip(urls, zipFileName);
        }
        
        this.overlay = false;
    }

    deleteOutboundDocument (item: IOutboundDocument) {
        confirm('Are you sure you want to delete this outbound document?') && this.deleteOutboundDocumentItem(item);
    }

    async deleteOutboundDocumentItem(outboundDocument: IOutboundDocument) {
        this.overlay = true;
        let result: boolean = await this.outboundDocumentApi.DeleteOutboundDocument(outboundDocument.id);
        if (result) {
            const index = this.outboundDocuments.indexOf(outboundDocument);
            this.outboundDocuments.splice(index, 1);
            this.showMessageInfo(`The outbound document ${outboundDocument.description} has been successfully deleted`);
        } else {
            const errors: string = this.outboundDocumentApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async uploadOutboundPicture(formData : FormData) {
        this.overlay = true;
        let urls: string[] = await this.uploadServiceApi.UploadDocuments(formData);
        for (let i in urls) {
            let outboundPicture: IOutboundPicture = {
                id: "",
                url: urls[i],
                idCompany: this.companyId,
                idOutbound: this.selectedOutbound!.id,
                urlBlob: ""
            };
            const id = await this.outboundPictureApi.SaveOutboundPicture(outboundPicture);
            if (id) {
                outboundPicture.id = id;
                outboundPicture.urlBlob = await this.uploadServiceApi.DownloadPictures(outboundPicture.url);
                this.outboundPictures.push(outboundPicture);
            } else {
                const errors: string = this.outboundPictureApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
        }
        this.showMessageInfo(`The outbound pictures has been successfully saved`);
        this.overlay = false;
    }

    async downloadOutboundPicture(outboundPicture: IOutboundPicture) {
        this.overlay = true;
        this.uploadServiceApi.DownloadPictures(outboundPicture.url);
        const errors: string = this.outboundApi.getModelError().join("; ");
        if (errors) {
            this.showMessageError("Cannot download the selected Picture from the Ftp location.");
        }
        this.overlay = false;
    }

    deleteOutboundPicture (item: IOutboundPicture) {
        confirm('Are you sure you want to delete this outbound Picture?') && this.deleteOutboundPictureItem(item);
    }

    async deleteOutboundPictureItem(outboundPicture: IOutboundPicture) {
        this.overlay = true;
        let result: boolean = await this.outboundPictureApi.DeleteOutboundPicture(outboundPicture.id);
        if (result) {
            this.outboundPictures = this.outboundPictures.filter(pic => pic.id !== outboundPicture.id);
            this.outboundPicturesCompanySource = this.outboundPicturesCompanySource.filter(pic => pic.id !== outboundPicture.id);
            this.outboundPicturesCompanyDestination = this.outboundPicturesCompanyDestination.filter(pic => pic.id !== outboundPicture.id);
            
            this.BlobsSource = this.BlobsSource.filter(blob => blob.id !== outboundPicture.id);
            this.BlobsDestination = this.BlobsDestination.filter(blob => blob.id !== outboundPicture.id);
            this.showMessageInfo(`The inbound Picture has been successfully deleted`);
        } else {
            const errors: string = this.outboundPictureApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    async saveOutboundDetail (stockListCustomerDetail: IStock[]) {
        this.overlay = true;
        for (let stockCustomerDetail of stockListCustomerDetail) {
            let outboundDetail : IOutboundDetail = await this.createdOutboundDetail(stockCustomerDetail);
            const id = await this.outboundDetailApi.SaveOutboundDetail(outboundDetail);
            if (id) {
                outboundDetail.id = id;
                this.selectedOutboundDetail = outboundDetail;
                this.OutboundDetailList = await this.outboundDetailApi.GetOutboundDetails(outboundDetail.idOutbound);
            }
        }
        this.showMessageInfo(`The outbound details has been successfully saved`);
        this.overlay = false;
    }

    async saveOutboundDeliveryNotesDetail(selectedStockCustomerToDelivery : IStock[]) {
        this.getOutboundDetails(this.selectedOutbound!.id);
        this.getOutboundDeliveryNotes(this.selectedOutbound!.id);
        this.OutboundDeliveryNotesDetailList = await this.outboundDeliveryNotesDetailApi.GetOutboundDeliveryNotesDetail(this.selectedOutboundDeliveryNotes!.id);
                
        this.showMessageInfo(`The outbound delivery note details has been successfully saved`);
    }

    deleteOutboundDeliveryNotesDetail (outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) {
        confirm('Are you sure you want to delete this outbound delivery note detail?') && this.deleteOutboundDeliveryNotesDetailItem(outboundDeliveryNotesDetail);
    }

    async deleteOutboundDeliveryNotesDetailItem(outboundDeliveryNotesDetail: IOutboundDeliveryNotesDetail) {
        this.overlay = true;
        let result: boolean = await this.outboundDeliveryNotesDetailApi.DeleteOutboundDeliveryNotesDetail(outboundDeliveryNotesDetail.id);
        if (result) {
            const index = this.OutboundDeliveryNotesDetailList.indexOf(outboundDeliveryNotesDetail);
            this.OutboundDeliveryNotesDetailList.splice(index, 1);
            this.getOutboundDetails(this.selectedOutbound!.id);
            this.showMessageInfo(`The outbound delivery note detail has been successfully deleted`);
        } else {
            const errors: string = this.outboundPictureApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    resetOutbound() {
        this.selectedOutbound = {
            id: "",
            idCompanySource: "",
            companySourceName: "",
            idCompanyDestination: "",
            companyDestinationName: "",
            idCustomer: "",
            customerName: "",
            idStatus: "",
            statusName: "",
            code: "",
            dateOut: new Date(),
            dossierNumber: "",
            weight: 0,
            liters: 0,
            deliveriesNumber: 0,
            description: "",
            containerNumber: "",
            sealNumber: "",
            orderNumber: "",
            startTime: 0,
            endTime: 0,
            dateChanged: false,
            entrepot: "",
            agp: "",
            referenceInboundCode: "",
            createdDate: new Date(),
            customerDestination: "",
            codeDestination: "",
            idListTypesOutbounds: "",
            listTypesOutboundsName: "",
            statusColor: "",
            customerDestinationCountry: ""
        };
        this.OutboundDetailList = [];
        this.OutboundDeliveryNotesList = [];
        this.OutboundDetailDeliveryNotesDetailList = [];
        this.outboundDocuments = [];
        this.outboundPictures = [];
        this.loadTimeSlots(new Date().toISOString().substring(0, 10), true, "", "", undefined);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
